import { defineComponent as _defineComponent } from 'vue'
import AiIcon from '@/components/svg/ai-icon-large.png';
import IconAccept from '@/components/svg/button/ok.svg?inline';
import IconEdit from '@/components/svg/edit-circle.svg?inline';
import IconDiscard from '@/components/svg/x-circle-2.svg?inline';
import IconReanalyze from '@/components/svg/reanalyze.svg?inline';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'AiSuggestionReviewBar',
  props: {
  disabledAll: Boolean,
  disableNewSuggestion: Boolean,
  isReanalyzing: Boolean,
},
  emits: ["accept", "edit", "discard", "new-suggestion", "cancel-reanalyze"],
  setup(__props) {





const { t } = useI18n();

return { __sfc: true,t, AiIcon, IconAccept, IconEdit, IconDiscard, IconReanalyze }
}

})